/*
 * Copyright (c) Nexign, JSC, 2020-2025.
 */
/**
 * The constants for the widget Search Accounts
 *
 * @author Anton Panasenko
 * @author Nikolay Sviridov
 * @version 1.36.0
 * @since 1.3.0
 */

import { IWidgetShowFields } from '../widgetTypes';

export const WIDGET_SEARCH_ACCOUNTS_LIST_LENGTH = 24;
export const WIDGET_SEARCH_ACCOUNTS_MIN_SEARCH_LENGTH = 2;
export const WIDGET_SEARCH_ACCOUNTS_INPUT_DELAY = 300;

/*
* -------------------------------------------
*           ACTIONS
* -------------------------------------------
*/
export const WIDGET_SEARCH_ACCOUNTS_INIT =
    '@@b2b_portal_ui/widgetSearchAccounts/WIDGET_SEARCH_ACCOUNTS_INIT';

export const WIDGET_SEARCH_ACCOUNTS_SET_SEARCH_VALUE =
    '@@b2b_portal_ui/widgetSearchAccounts/WIDGET_SEARCH_ACCOUNTS_SET_SEARCH_VALUE';

export const WIDGET_SEARCH_ACCOUNTS_SET_ACCOUNT =
    '@@b2b_portal_ui/widgetSearchAccounts/WIDGET_SEARCH_ACCOUNTS_SET_ACCOUNT';

export const WIDGET_SEARCH_ACCOUNTS_LOAD_LIST =
    '@@b2b_portal_ui/widgetSearchAccounts/WIDGET_SEARCH_ACCOUNTS_LOAD_LIST';
export const WIDGET_SEARCH_ACCOUNTS_LOAD_LIST_SUCCESSFUL =
    '@@b2b_portal_ui/widgetSearchAccounts/WIDGET_SEARCH_ACCOUNTS_LOAD_LIST_SUCCESSFUL';
export const WIDGET_SEARCH_ACCOUNTS_LOAD_LIST_FAILED =
    '@@b2b_portal_ui/widgetSearchAccounts/WIDGET_SEARCH_ACCOUNTS_LOAD_LIST_FAILED';

/*
* -------------------------------------------
*           DEFAULT VALUES
* -------------------------------------------
*/
export const showFieldsDefault: IWidgetShowFields = {
    id: true,
    number: true,
    region: true,
    balance: true,
    subsCount: true,
    name: false,
    inn: false,
}
